import { establecimientoApi } from '../../utils/api';
import {
  getObjectDataAction,
  createObjectDataPending,
  getListDataAction,
  saveObjectDataAction,
  deleteObjectDataAction,
  getListDeletedDataAction,
  createListDataDeletedPending,
  restoreObjectDataAction,
} from '../../utils/DataAction';

export const get = (id) =>
  getObjectDataAction({
    dataName: 'ESTABLECIMIENTO',
    api: establecimientoApi,
    relUrl: id,
  });

export const getAll = getListDataAction({
  dataName: 'ESTABLECIMIENTO',
  api: establecimientoApi,
  relUrl: '',
});

export const save = (data) =>
  saveObjectDataAction({
    dataName: 'ESTABLECIMIENTO',
    api: establecimientoApi,
    relUrl: '',
    data: data,
  });

export const deleted = (id) =>
  deleteObjectDataAction({
    dataName: 'ESTABLECIMIENTO',
    api: establecimientoApi,
    relUrl: id,
  });

export const getAllDeleted = getListDeletedDataAction({
  dataName: 'ESTABLECIMIENTO',
  api: establecimientoApi,
  relUrl: 'restore',
});

export const restore = (data) =>
  restoreObjectDataAction({
    dataName: 'ESTABLECIMIENTO',
    api: establecimientoApi,
    relUrl: 'restore',
    data: data,
  });

export const setPending = createObjectDataPending('ESTABLECIMIENTO');
export const setDeletedPending =
  createListDataDeletedPending('ESTABLECIMIENTO');
